import React from 'react'
import { Grid, Typography, Button, Hidden, IconButton } from '@material-ui/core'
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import { useTheme } from 'styled-components'
import useIntl from 'hooks/useIntl'
import Modal, { IModalProps } from 'components/Modal'
import Accordion from 'components/Accordion'
import ColoredCard from 'components/ColoredCard'
import { CoreChapterResultFieldsFragment } from 'hooks/useApollo'

import { Check, Close } from '@material-ui/icons'
import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles(theme => ({
	dialogTitle: {
		width: '100%',
		maxWidth: '100%',
		backgroundColor: 'rgb(125, 110, 241)'
	},
	correctanswerTitle: {
		color: 'white',
		fontWeight: 'bold',
		backgroundColor:
			theme.palette.mode === 'dark'
				? theme.palette.success.dark
				: theme.palette.success.light,
		padding: '4px 8px',
		borderRadius: '4px',
		display: 'inline-block',
		marginLeft: '8px'
	}
}))
export interface ViewSubmissionModalProps {
	className: string
	modalProps: Omit<IModalProps, 'title'>
	title: string
	desc: string
	data: CoreChapterResultFieldsFragment
	onNext: () => void
	onPrev: () => void
	isFirstIndex: boolean
	isLastIndex: boolean
	nextText?: string
	prevText?: string
}

export const ViewSubmissionModal: React.FC<ViewSubmissionModalProps> = ({
	className,
	modalProps,
	title,
	desc,
	data,
	onNext,
	onPrev,
	isFirstIndex,
	isLastIndex,
	nextText,
	prevText
}) => {
	const theme = useTheme()
	const intl = useIntl()
	const classes = useStyles()
	return (
		<Modal
			{...modalProps}
			size="big"
			title={title}
			showCloseButton
			footer={false}
			// className={classes.dialogTitle}
		>
			<Grid container spacing={2}>
				<Grid item>
					<Typography variant="paragraph1" sx={{ color: theme.text.description }}>
						{desc}
					</Typography>
				</Grid>
				<Grid item>
					{data?.parts?.map(
						(
							{
								id,
								type,
								scene,
								title,
								question,
								instruction,
								answer,
								correctAnswer,
								options
							},
							index
						) => (
							<Accordion key={id} label={`${scene} ${title}`} defaultExpanded={index === 0}>
								<Grid container spacing={2}>
									<Grid item xs={12}>
										<ColoredCard color={theme.tag.yellow}>
											{!correctAnswer && (
												<Typography fontWeight={500}>{question}</Typography>
											)}
											<Typography fontWeight={500} mt={2}>
												{instruction}
											</Typography>

											{type === 'options' && correctAnswer && (
												<Typography sx={{ mt: 2, color: theme.text.description }}>
													{intl.formatMessage({ id: 'challengeSubmission.instruction' })}
												</Typography>
											)}
										</ColoredCard>
									</Grid>

									<Grid item>
										<Typography gutterBottom>
											{intl.formatMessage({ id: 'answer' })}:
										</Typography>
										{type === 'options' && (
											<Typography sx={{ color: theme.text.description }}>
												{intl.formatMessage({
													id: 'challengeSubmission.orderedListSubmission'
												})}
											</Typography>
										)}
									</Grid>

									{type === 'options' && options && (
										<Grid item xs={12}>
											<Grid container spacing={2}>
												{options.map((ans, index) => {
													const isCorrect =
														Array.isArray(correctAnswer) && correctAnswer.includes(ans)
													const isUserAnswer = ans === answer
													const isMatched = isUserAnswer && isCorrect
													const isIncorrect = isUserAnswer && !isCorrect

													return (
														<Grid key={index} item xs={12}>
															<ColoredCard color={theme.grey.third}>
																<Typography
																	sx={{
																		color: isUserAnswer
																			? isMatched
																				? 'green'
																				: 'red'
																			: theme.text.description,
																		display: 'flex',
																		alignItems: 'center'
																	}}
																>
																	{ans}
																	{isMatched && (
																		<Check sx={{ fontSize: 16, ml: 1, color: 'green' }} />
																	)}
																	{isIncorrect && (
																		<Close sx={{ fontSize: 16, ml: 1, color: 'red' }} />
																	)}
																</Typography>
															</ColoredCard>
														</Grid>
													)
												})}
											</Grid>
										</Grid>
									)}

									{correctAnswer && (
										<>
											{type === 'answer' && (
												<Grid item>
													<Typography>
														{intl.formatMessage({ id: 'answer' })}: {answer || ''}
													</Typography>
												</Grid>
											)}

											{/* <Grid item>
												<Typography gutterBottom>
													{intl.formatMessage({ id: 'Correct Answer' })}:
												</Typography>
												<Typography sx={{ color: theme.text.description }}>
													{correctAnswer}
												</Typography>
											</Grid> */}
											<Grid item>
												<Typography
													gutterBottom
													sx={{
														padding: '4px 8px',
														borderRadius: '4px',
														display: 'inline-block'
													}}
												>
													{intl.formatMessage({ id: 'Correct Answer' })}:
												</Typography>
												<Typography
													// sx={{
													// 	color: theme.palette.success.main,
													// 	fontWeight: 'bold',
													// 	backgroundColor:
													// 		theme.palette.mode === 'dark'
													// 			? theme.palette.success.dark
													// 			: theme.palette.success.light,
													// 	padding: '4px 8px',
													// 	borderRadius: '4px',
													// 	display: 'inline-block',
													// 	marginLeft: '8px'
													// }}
													className={classes.correctanswerTitle}
												>
													{correctAnswer}
												</Typography>
											</Grid>
										</>
									)}
								</Grid>
							</Accordion>
						)
					)}
				</Grid>

				<Grid item container justifyContent="space-between">
					<Grid item xs={6} container justifyContent="flex-start">
						{!isFirstIndex && (
							<>
								<Hidden smDown>
									<Button
										sx={{ color: theme.tag.blue }}
										size="small"
										name="prev"
										onClick={onPrev}
										startIcon={<ArrowBackIcon fontSize="small" />}
									>
										{prevText}
									</Button>
								</Hidden>
								<Hidden smUp>
									<IconButton
										sx={{ ml: -1.5, color: 'link.main' }}
										color="primary"
										onClick={onPrev}
									>
										<ArrowBackIcon />
									</IconButton>
								</Hidden>
							</>
						)}
					</Grid>

					<Grid item xs={6} container justifyContent="flex-end">
						{!isLastIndex && (
							<>
								<Hidden smDown>
									<Button
										name="next"
										size="small"
										onClick={onNext}
										sx={{ color: theme.tag.blue }}
										endIcon={<ArrowForwardIcon fontSize="small" />}
									>
										{nextText}
									</Button>
								</Hidden>
								<Hidden smUp>
									<IconButton sx={{ mr: -1.5, color: 'link.main' }} onClick={onNext}>
										<ArrowForwardIcon />
									</IconButton>
								</Hidden>
							</>
						)}
					</Grid>
				</Grid>
			</Grid>
		</Modal>
	)
}

export default ViewSubmissionModal
